import { useQuery } from '@tanstack/react-query';
import { getEripDeposit } from '@/widgets/account-operations/api/requests';
import type { EripDepositResponse } from '@/shared/types';
import { CACHE_TIME_10_MINUTES, CACHE_TIME_5_MINUTES } from '@/shared/config';

export function useEripDeposit() {
  const query = useQuery<EripDepositResponse, Error>({
    queryKey: ['getEripDeposit'],
    queryFn: getEripDeposit,
    staleTime: CACHE_TIME_5_MINUTES,
    gcTime: CACHE_TIME_10_MINUTES,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    status: query.status,
    refetch: query.refetch,
  };
}
